<template>
  <div class="title">
    <h1>Contact</h1>
    <p>
      I can be reached via <a href="https://linkedin.com/in/astopo">LinkedIn</a>, or by email at <a href="mailto:amy@soetopo.com">amy@soetopo.com</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  props: {}
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
